import { RoutingNote } from '@/components/RoutingNote'
import JobRouteOptimization from './JobRouteOptimization'

const RoutingMapHeader = () => {
    return (
        <div className='my-5'>
            <RoutingNote />
            <JobRouteOptimization />
        </div>
    )
}

export default RoutingMapHeader
